import { getLogger } from 'utils/logger';
const configRaw = require('webappConfig');  // eslint-disable-line

const log = getLogger('utils/webappConfig.js');

export const HOSTNAME = window.location.hostname || 'localhost';
export const PORT = window.location.port;
export const PROTOCOL = window.location.protocol || 'http:';
export const ENVIRONMENT = process.env.SERVICE_ENV || configRaw.hosts[HOSTNAME].environment_default || 'prod';
export const BUILD_TYPE = configRaw.hosts[HOSTNAME].build_override || process.env.NODE_ENV || 'production';

function processConfig(config) {

  const newConfig = {};
  Object.keys(config).forEach((key) => {
    let keyObj = config[key];
    if (typeof(config[key]) === 'object' && !Array.isArray(config[key])) {
      keyObj = processConfig(config[key]);
    } else {
      keyObj = typeof(config[key]) === 'string' ? config[key].replace('ENV_PORT', PORT) : config[key];
    }
    newConfig[key] = keyObj;
  });

  return newConfig;
}

export const Config = processConfig(configRaw);

log.info(
  '\nEnvironment:\n' +
  `HOSTNAME = ${HOSTNAME}\n` +
  `PORT = ${PORT}\n` +
  `PROTOCOL = ${PROTOCOL}\n` +
  `SERVICE_ENV = ${process.env.SERVICE_ENV}\n` +
  `ENVIRONMENT = ${ENVIRONMENT}\n` +
  `NODE_ENV = ${process.env.NODE_ENV}\n` +
  `BUILD_TYPE = ${BUILD_TYPE}\n`,
  Config,
  process
);
